<template>
  <div class="container wont-take-vaccine-result ">
    <div class='col-12 title text-left'>
      {{ $t('results.whyConcerned') }}
    </div>
    <div class='col-12 pt-2 pl-0 pr-0 chart'>
      <div class='wont-take-vaccine-chart' ref='whyconcernedchart'></div>
    </div>
  </div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_material from '@amcharts/amcharts4/themes/material'

if (process.env.NODE_ENV === 'production') {
  am4core.options.commercialLicense = true
}

am4core.options.onlyShowOnViewport = true

am4core.useTheme(am4themes_material)

export default {
  data () {
    return {
      chart: null
    }
  },
  computed: {
    whyConcerned () {
      return this.$store.getters.getWhyConcerned
    }
  },
  methods: {
    loadChart () {
      this.chart = am4core.create(this.$refs.whyconcernedchart, am4charts.XYChart)

      this.chart.hiddenState.properties.opacity = 0
      this.chart.numberFormatter.numberFormat = '#.'
      this.chart.paddingLeft = 0

      this.chart.data = this.whyConcerned

      let categoryAxis = this.chart.yAxes.push(new am4charts.CategoryAxis())
      categoryAxis.dataFields.category = 'risk'
      categoryAxis.renderer.inversed = true
      categoryAxis.renderer.grid.template.location = 0
      categoryAxis.renderer.minGridDistance = 40

      let label = categoryAxis.renderer.labels.template
      label.wrap = true
      label.maxWidth = 80
      label.fontSize = '.8rem'

      let valueAxis = this.chart.xAxes.push(new am4charts.ValueAxis())
      valueAxis.renderer.minGridDistance = 60
      valueAxis.fontSize = 10
      valueAxis.title.text = this.$t('results.noOfRespondents')
      valueAxis.title.fontSize = 12
      valueAxis.extraMax = 0.5

      let series = this.chart.series.push(new am4charts.ColumnSeries())
      series.dataFields.categoryY = 'risk'
      series.dataFields.valueX = 'participants'
      series.name = 'participants'
      series.stroke = am4core.color('#2bb1c4')
      series.fill = am4core.color('#2bb1c4')
      series.columns.template.height = am4core.percent(30)
      series.calculatePercent = true

      let valueLabel = series.bullets.push(new am4charts.LabelBullet())
      valueLabel.label.text = '{valueX.percent}%'
      valueLabel.label.truncate = false
      valueLabel.label.fontSize = 12
      valueLabel.label.horizontalCenter = 'left'
      valueLabel.label.dx = 10
    }
  },
  mounted () {
    this.loadChart()
  },
  watch: {
    whyConcerned () {
      this.loadChart()
      this.chart.invalidateRawData()
    }
  }
}
</script>

<style>
.wont-take-vaccine-result .title {
  font-weight: 700;
  font-size: 1.2rem !important;
}

.wont-take-vaccine-result  .chart, .wont-take-vaccine-chart {
  width: 100%;
  height: 40vh;
}
</style>
